export default {
  methods: {
    getHumanReadableReason(reason) {
      const map = {
        w1: 'c.table.cellHighCTRFilter',
        w2: 'c.table.cellHighCTRFilter',
        w3: 'c.table.cellHighCTRFilter',
        d1: 'c.table.cellHighCTRFilter',
        d2: 'c.table.cellHighCTRFilter',
        d3: 'c.table.cellHighCTRFilter',

        w4: 'c.table.cellPerformanceFilter',
        w5: 'c.table.cellPerformanceFilter',
        d4: 'c.table.cellPerformanceFilter',
        b1: 'c.table.cellPerformanceFilter',

        w6: 'c.table.cellDNSFilter',

        w7: 'c.table.cellGlobalBlackList',

        w8: 'c.table.cellUserBlackList',

        w9: 'c.table.cellManuallyAdded'
      }

      const messageKey = map[reason]

      return messageKey ? this.$t(messageKey) : reason
    },

    getHumanReadablePeriod(period) {
      const finalValue = period === '' ? 'ALL_TIME' : period

      const { dateRangeArray } = this.$store.state.dictionary
      const dateRange = dateRangeArray.find(dr => dr.value === finalValue)

      return dateRange && dateRange.key ? this.$t(dateRange.key) : finalValue
    },

    getCampaignName(campaign) {
      return campaign || 'Аккаунт'
    }
  }
}
